export default {
  accountValidateMsg:
    '账号必须为6-30位字符，包括字母、数字、“.”、“_”、“@”，第一位字符仅能为数字或字母。',
  storeSuccess: '储值成功',
  editAccountTips: '请输入有效账号',
  editPwdTips: '请输入有效密码',
  editRepeatPwdTips: '请重复输入密码',
  pwdRepeatTips: '两次密码不匹配',
  changePwdSucc: '修改密码成功',
  bindEmail: '绑定邮箱',
  verifyEmail: '账号安全验证',
  errorVrifyCodeTips: '验证码错误',
  slectQuessionTips: '请选择安全问题',
  answerTips: '请输入答案',
  twoAnswerTips: '请选择两个您已经设置的安全问题，并输入正确答案。',
  realNameValidateTips: '请输入4~60位的真实姓名',
  phoneValidateTips: '请输入6～18位数字的电话号码',
  areaSelectTips: '请选择正确的国家地区',
  iDCardValidataTips: '请输入1~60位的身份证号码',
  changeProfileSucc: '信息编辑成功',
  editVrfCodeTips: '请输入验证码',
  securityQuestionTips:
    '请设置您的安全问题，提升您的账号安全。当您忘记密码时，可以通过回答安全问题快速重置密码。',
  validateQuessionTips:
    '请选择两个不同的问题并进行认证，认证完成后便可重置安全问题。',
  originPwd: '请输入旧密码',
  newPwd: '请输入新密码',
  changePwdSuccess: '修改密码成功，请手动重新登入账号，防止数据丢失',
  accountName: '请输入帐号名称',
  password: '请输入密码',
  repeatPassword: '请再重复密码',
  findPwdTips: '请输入您需要找回密码的帐号名称',
  submit: '提交',
  send: '发送',
  modify: '修改',
  haveAgree: '我已同意',
  and: '和',
  privacyPolicy: '隐私策略',
  completeness: '资料完成度:',
  gender: '性别',
  male: '男',
  female: '女',
  birthday: '生日',
  phone: '联系电话',
  region: '国家／地区',
  ID: '护照或身份证号码',
  accountSetting: '账号设置',
  upgrade: '账号升级',
  profile: '个人资料',
  changePassword: '修改密码',
  securityQuestion: '安全问题',
  creatework_headerTitle: '创建工单',
  creatework_roworldTitle: '创建工单 · 冒险者求助',
  creatework_roworldSubTitle: '客服将尽快为您排忧解难',
  mylist_headerTitle: '我的工单',
  bindEmailTips:
    '请认证一个您的常用邮箱，提升您的账号安全。当您忘记密码时，可通过此邮箱快速重置密码。',
  verifyEmailTips: '检测到您的账号正在新设备或异常环境下登录，为了保障您的账号资产安全，请完成身份验证。',
  enterEmailVrfcationTips: '请输入收到的验证码',
  cancel: '取消',
  bindTps: '选择账户绑定的方式可以让你在数台设备中以您的账号来进行游戏!',
  login: '登入',
  logout: '登出',
  bind: '帐户绑定',
  feedback: '问题反馈',
  terms: '相关条款',
  tips: '提示',
  debindTips:
    '解除绑定可能会导致您的账号数据丢失，请您再次确认是否需要解除绑定！',
  debindText: '解除绑定',
  guestSwitchTips:
    '您当前已经有游客账户存在，登录后当前游客账户会丢失，请问确认要登录吗？',
  register: '注册',
  realName: '真实姓名',
  enterEmailTips: '请输入邮箱地址',
  emailVAlidateMsg: '邮箱格式错误',
  editEmaileTips: '请输入邮箱',
  checkServiceTips: '请先阅读并接受服务条款和隐私政策！',
  brithdayValidateTips: '请选择正确的生日',
  facebookValidateTips: '请输入1~60位的facebook账号',
  eritOriginPwdTips: '请输入原密码',
  submitSuccess: '提交成功',
  rebindEmail: '修改邮箱',
  bindEmailSuccess:
    '您已成功绑定邮箱$email</br>使用已绑定邮箱进行认证，认证完成便可重置邮箱。',
  reSetSecurityQuessoon:
    '您已经成功设置安全问题<br/><br/>选择不同的问题并进行认证，认证完成后便可重置问题',
  canotModifyTips: '个人资料信息提交后将不能更改，是否提交？',
  rebindEmailTips: '您的邮箱 $email,请点击获取验证码并输入您收到的验证码',
  reGetVrfCode: '获取验证码',
  findPwdWayTips: '请选择以下方式找回',
  emailWay: '通过安全邮箱找回',
  emailWayTips: '你将收到一封确认邮件，可以重新设置密码。',
  quessionWay: '通过安全问题找回',
  quessionWayTips: '回答已经设置的安全问题，可以重新设置密码。',
  resetPwdBtn: '重置密码',
  lastStep: '上一步',
  sendEmailTips:
    '我们已经向您的认证邮箱$email发送确认邮件。<br>请将您收到的验证码正确填入对话框中。',
  setNewPwdTips:
    '恭喜！<br>您可以重新设置密码了，请在对话框中输入您的新密码吧！',
  termsOfUse: '服务条款',
  copy_success: '复制成功',
  creatework_create: '工单类',
  creatework_createHolder: '请选择类型',
  creatework_title: '标题',
  creatework_titleHolder: '请输入标题',
  creatework_detail: '问题详情',
  creatework_detailHolder: '请输入200字以内的问题详情',
  creatework_uploadTips: '只能上传jpg/png格式文件，文件不能超过5mb',
  creatework_selectBox_selectTile: '问题类型',
  creatework_goGame: '返回游戏',
  creatework_history: '工单历史',
  mylist_noYet: '您还没有任何工单记录喔',
  mywork_solved: '问题已解决了？点我',
  mywork_service: '给客服评分',
  mywork_messageHolder: '请输入新消息',
  mywork_score: '请选择评分',
  mywork_confirm: '确认',
  creatework_selectBox_selectList3: '其他问题',
  creatework_selectBox_selectList2: '帐号问题',
  close: '关闭',
  creatework_gameHolder: '请选择游戏',
  creatework_serverHolder: '请选择服务器',
  contactService: '联系客服',
  FAQ: 'FAQ',
  creatework_game: '游戏：',
  creatework_server: '伺服器：',
  creatework_role: '角色：',
  selectRoleName: '请选择角色',
  creatework_noRole: '还没有创建角色',
  creatework_noGame: '游戏列表为空',
  creatework_noServer: '服务器列表为空',
  termText: '我已同意{mainHost}平台',
  backLogin: '返回登录',
  creatework_roleHolder: '请选择角色后再访问',
  findPwdFailTips:
    '您没有设置安全问题和安全邮箱，无法通过这种方式找回，请联系客服。',
  payMall: '储值商城',
  selectPayment: '选择金额',
  plzSelectPayWay: '请选择您的渠道',
  gainPlus: '加码',
  gainMorePlus: '加码多多',
  gainMostPlus: '最高加码',
  plzSelectPayType: '选择储值方式',
  roleName: '角色名',
  payWay: '支付渠道',
  plzSelectOtherWay: '选择其他支付渠道',
  payment: '支付金额',
  compensateTips: '超出商品价值部分将额外补偿$gameCode给您',
  extaGain: '额外获得',
  gameGold: '游戏币',
  compensate: '补偿',
  payWayPlus: '渠道加码',
  neddPay: '需支付',
  submitOrder: '提交订单',
  screenshotTips: '温馨提示：截图保存订单信息，后续遇到问题方便反馈哦！',
  storeFail: '储值失败',
  storeFailTips:
    '非常抱歉本次储值失败了，请您尝试重新提交订单，或通过客服工单联系我们',
  storeAcceptance: '受理中',
  storeSuccessTips: '储值成功后通常在15MIN内到账，请稍后于游戏内查看',
  orderNumber: '订单号',
  buyProduct: '储值商品',
  transactionAmount: '交易金额',
  failReason: '失败原因',
  payOntherORder: '再储一笔',
  reStore: '重新储值',
  confirm: '确定',
  switch: '帐号切换',
  completeTips:
    '请填写您的个人资料， 以下信息<mark class="yellowMarkColor">填写后将不允许修改</mark>.当您的账号丟失或被盗用时，可通过向客服提供准确的个人资料信息作为取回账号的依据。',
  creatework_selectBox_selectList0: '游戏问题',
  creatework_selectBox_selectList1: '支付问题',
  creatework_selectBox_selectList4: '翻译问题',
  mywork_solvedText: '问题已解决',
  browserPayErrBtnText: '交易遇到问题',
  browserPaySucBtnText: '已完成支付',
  browserPayingTips:
    '您正在前往第三方平台进行支付,<br/>完成支付后即可关闭此页面。',
  price_list_empty: '无可选金额',
  pointCardTips: '注意：商品仅支持等于 $paymentAmount 的 点卡购买',
  forgetPwd: '忘记密码',
  payCenter: '平台储值中心',
  willGet: '您将获得',
  goods: '商品',
  discount: '额外赠送',
  payDiscount: '支付补偿',
  payDiscountTips: '超出商品价格将进行支付补偿',
  hasQuestionPlease: '如有疑问，请',
  pwdValidateMsg: '密码必须为6-20位字符',
  payWayPlusC: '渠道赠送',
  fwtk: '服务条款',
  yszc: '隐私政策',
  exchange: '礼包码兑换',
  remember: '记住我',
  thirdInfo: '账号规则说明',
  thirdInfoContent:
    '请在游戏内的用户中心完成账号绑定，再使用绑定的账号进行登录。',
  unLink: '暂不支持此方式',
  favour: '收藏游戏',
  goStoreTip: '请跳转前往储值页面',
  go: '前往',
  otherLogin: '其它登录方式',
  qrCodeTip: '扫一扫二维码,马上开启旅程吧!',
  favourTip: '收藏页面到浏览器，方便下次再玩喔～',
  share: '分享给朋友',
  landscapeTip: '请用竖屏方式进行操作',
  leaveTip: '您真的要离开游戏吗？',
  selectRole: '请选择您要充值的角色',
  selectMoney: '请选择想购买的道具',
  seletGameInfoFirst: '请先选择游戏信息',
  lowerIE: '您的ie版本过低',
  linkTermText: '我已同意{mainHost}平台[服务条款]和[隐私政策]',
  download: '下载',
  favourAndDownloadTip: '收藏到浏览器或者下载到电脑&lt;br/&gt;方便下次再玩',
  payReward: '支付有奖',
  hasEqualReward: '两种支付方式同享首充双倍等优惠',
  payBtnText: '支付',
  storeHoaveReward: '充值优惠',
  showMorePayWay: '展开更多支付方式',
  needPaymentCount: '需要支付金额',
  orderDetail: '订单详情',
  selectPayWayPlz: '选择支付方式',
  countryCode: '国别码',
  deleteaccount_title1: '账号信息删除',
  deleteaccount_title2: '账号删除申请',
  deleteaccount_step1_1:
    '如果您执行帐号删除后，您的帐号会被冻结14日。14日后您的帐号会被系统永久删除，并且社交账号后续也无法登入。',
  deleteaccount_step1_2: '在冻结期间，您可以通过以下链接取消账号删除的请求',
  deleteaccount_step1_3:
    '帐号删除后帐号所有资料全部清除且无法恢复，因帐号删除造成的任何账号财产损失也无法得到补偿',
  deleteaccount_step1_4: '您是否需要这样做？',
  deleteaccount_step2_1: '您确认要删除当前账号以及游戏内所有角色信息？',
  deleteaccount_step2_2: '请在输入框中输入“Delete”来完成删除操作',
  deleteaccount_step3: '账号删除会在申请的14天后开始执行。',
  accountrecovery_note: '提示：',
  accountrecovery_tips: '账号删除恢复仅在申请删除的冻结期间有效。',
  accountrecovery_Submitted2:
    '账号删除恢复申请已经提交，稍后您角色对应的账号删除申请将被取消。',
  accountrecovery_Failed: '提交失败',
  accountrecovery_Failed_1: '申请的账号目前处于正常状态，可以正常登录游戏。',
  accountrecovery_Failed_2: '角色信息无法查询，请重新输入。',
  accountrecovery_success: '帳號恢復成功',
  account_normal: '账号状态正常，无需恢复',
  account_unablerestore: '账号已被注销，无法恢复',
  accountrecovery_roleHolder: '请输入角色名称',
  accountrecovery_headerTitle: '账号删除冻结恢复',
  guideTitle:
    'Your purchase is not successful. Please contact our customer service.',
  accountFix: '账号修复',
  inputAccount: '请输入您需要修复的账号名称',
  applyForAccountFix: '申请账号修复',
  nonEnterItem:
    '您还没填写的项有：注册时间，常用设备号，常用手机型号，护照或身份证号，联系邮箱；请先填写',
  resetOT: '重置已超时，请重新提交审核',
  addOT: '补充资料已超时，请重新提交审核',
  errorPwd: '密码必须为6-20位字符，包括字母、数字、"."、"_"、"@"',
  verifyAccount: '缺少用户账号信息，请重新验证',
  selectRegisterTime: '请选择注册时间',
  enterBindEmail: '请正确填写已经绑定邮箱',
  enterUsedPhoneType: '请填写常用手机型号',
  enterIdfaGpid: '请填写常用设备号',
  enterContactEmail: '联系邮箱格式不正确，请重新填写',
  confirmTermsPrivacy: '请同意服务条款和隐私策略',
  enterRechargeRemark: '请输入充值记录',
  uploadImg: '请上传清晰完整的身份证扫描件',
  selectIDType: '请选择身份证类型',
  enterIDNum: '请输入护照号码或身份证号码',
  enterIP: '请输入注册所在IP',
  enterQueryNum: '请输入查询号',
  enterQueryPwd: '请输入查询密码',
  errorQueryItem: '查询号或查询密码有误，请重新输入',
  enterPassword: '请输入新密码',
  enterPasswordAgain: '请再输入新密码',
  enterPasswordNonSame: '两次密码不匹配',
  enterEmail: '请输入邮箱地址',
  sendSuccess: '邮件已经发送成功',
  enterCode: '请输入验证码',
  errorCode: '输入的验证码错误',
  selectQuest: '请选择安全问题',
  enterAnswer: '请输入答案',
  selectDifferQuest: '请选择三个安全问题，并回答',
  addSuccess: '资料补充成功',
  picFormt: '图档格式须为JPG、PNG或GIF格式',
  countdownBefore: '重置信息有效期：',
  countdownAfter: '（当时间变为00:00:00时，链接将会失效，请重新提交账号修复）',
  uploadDone: '上传成功',
  uploadFail: '上传失败',
  applySuccess: '申请成功',
  applyFailed: '申请失败',
  resetQuestAlterFailed: '安全问题修改失败',
  resetQuestError: '数据输入有误',
  resetQuestNone: '未查询到订单',
  resetQuestAltered: '已经修改过安全问题',
  illegalOperation: '非法操作',
  queryNotExist: '查询号不存在',
  queryPasswordError: '查询密码错误',
  auditing: '审核中',
  notPass: '不通过',
  suppleInformation: '补充资料',
  suppleInformationUnHandle: '已补充资料，客服未处理',
  suppleInformationTimeout: '资料补充超时',
  repairedAccountSuccess: '账号修复已经完成',
  repairedAccountLost: '账号修复操作，已经失效',
  loginStateNone: '未登陆或者session已经失效',
  repairedAccountTimeout: '账号修复时间已经超时',
  changePasswordSucc: '密码修改成功',
  emailSendFailed: '邮件发送失败',
  emailSendLimit: '该邮箱今日发送验证码次数已达上限',
  repairedAccountTimeout2: '非法操作账号修复时间已经超时',
  emailCodeSended: '邮件验证码已经发出',
  alterSuccess: '修改成功',
  questionAlterSuccess: '安全问题修改成功',
  username: '请输入账号名称',
  code: '请输入验证码',
  selectServiceType: '请选择服务类型',
  submitForm: '通过提交表单的方式来修复您的账号',
  apply: '申请修复',
  reviewApplicationStatus: '修复进度查询',
  instantReviewOfTheStatus: '实时查看账号修复的进度',
  reviewStatus: '查询进度',
  backToLogin: '返回登录页',
  previous: '上一步',
  applyDesc:
    '以下资料请尽量保持完整，以便我们能够为您迅速解决问题，*为必填项，如果账号未设置此资料，请填写无。',
  additionalServices: '附加服务',
  resetSecurityEmail: '重置安全邮箱',
  resetSecurityQuest: '重置安全问题',
  registrationDate: '注册时间',
  month: '月',
  year: '年',
  emailBound: '请补充已绑定的邮箱',
  modelNumber: '补充常用手机型号；',
  deviceName: '请补充常用手机型号',
  provideRecharge:
    '请您提供详细、完整的充值记录，包括充值的方式、时间、金额以及相关的订单号或交易序号，以便我们为您核查。',
  selectCountry: '选择地区',
  passportID: '护照或身份证',
  upload: '上传',
  del: '删除',
  pleaseUpload: '请提供清晰完整的身份证扫描件，大小不超过20M',
  uploadAgain: '重新上传',
  enterDesc: '如有其他可证明账号归属的内容，请在这里填写',
  contactEmail: '联系邮箱',
  applyNoteAttr: '温馨提示：',
  applyNoteDate:
    '为了能夠及时收到本次申诉的进度、结果，请您提供可接收信息的邮箱地址',
  agree: '我已同意',
  UJOYTerms: 'UJOY服务条款',
  privacy: '隐私策略',
  reviewStatusOfAccountFix: '修复进度查询',
  enterReviewID: '请输入查询号',
  enterReviewPwd: '请输入查询密码',
  review: '查询',
  reviewNoteAttr: '温馨提示：',
  reviewNoteData:
    '如果您不小心遗失查询号、查询密码，可在您提供的联系邮箱中查看',
  haveResetInfo: '您已经重新设置您的信息！',
  resetProfile: '重置您的信息',
  desc: '恭喜您，审核通过！请重新设置您的信息。',
  changePwd: '修改密码',
  resetPwd: '重新设置一个密码',
  reset: '修改',
  enterNewPwd: '请输入新密码',
  confirmNewPwd: '请重复新密码',
  successResetPwd: '您的新密码已设置成功',
  bindSecurityEmail: '绑定安全邮箱',
  resetPwdDesc: '用于忘记密码或者账号被盗时快速重置密码',
  bindCommon: '绑定',
  sendCommon: '发送',
  enterVcode: '请输入收到的验证码',
  successResetEmail: '您的安全邮箱已重置成功',
  resetQuest: '重置安全问题',
  resetQuestDesc: '用于忘记密码或者账号被盗时快速重置密码',
  successResetQuest: '您的安全问题已重置成功',
  hide: '收起',
  addRegisterTime: '补充注册时间；',
  modelNum: '请补充常用设备号：IDFA/GPID',
  registrationIP: '补充账号注册所在IP；',
  addRechargeRecord: '补充储值记录；',
  serviceReply: '客服回复：',
  addDataLimitTime: '补充资料有效期：',
  addMoreInfo: '补充更多资料',
  applicationSubmit: '申请提交成功',
  underReviewStatus:
    '您的资料目前正在审核中，我们将在一个工作日内给您答复，您也可以通过以下方式查看进度：',
  reviewID: '查询号：',
  reviePwd: '查询密码：',
  enterReviewIDNPwd:
    '在账号修复进度查询页面上，输入查询号、查询密码即可查看当前处理进度',
  homepage: '返回首页',
  checkEmailAttr: '温馨提示：',
  checkEmailData:
    '如果您不小心遗失查询号、查询密码，可在您提供的联系邮箱中查看',
  underReview: '资料审核中',
  underReviewReply: '资料正在审核中，请您耐心等候，我们会尽快給您答复！',
  failed: '审核未通过',
  reason:
    '原因：由于您所提供的###因此审核未能通过，请您提供正确信息，相关人员会尽快为您进行处理，感谢您的配合，谢谢！',
  underReviewAdd:
    '资料正在审核中，因部分资料不一致或者为空，请您提供更多的资料以便我们为您核实！',
  addInfoRequired: '需要补充资料：',
  dateForAddInfo: '补充资料有效期：',
  addInfo: '补充资料',
  addInfoSubmit: '补充资料已提交，请等待审核！',
  hasBeenRepaired: '账号修复已经完成',
  opExpired: '账号修复操作，已经失效',
  approved: '审核通过',
  haveSubmitted: '您已经补充过资料了',
  sessionExpired: '您还未登陆或值session已失效',
  submitted: '补充成功',
  addItemRegisterDate: '补充绑定邮箱；',
  addItemDeviceNumber: '补充常用设备号；',
  reasonItemPwd: '身份证号码不符；',
  addItemIDPhoto: '补充清晰有效证件；',
  idfaTitle: '如何在苹果手机查找IDFA以及安卓手机ID?',
  idfaSubTitle1: '一、如何查找IDFA',
  idfaSubTitle1Desc1: '1、在appsotre下载【<em>MyIDFA</em>】',
  idfaSubTitle1Desc2:
    '2、下载完成后进入<em>APP</em>即可看到本机的<em>IDFA码</em>。',
  idfaSubTitle2: '二、如何查找谷歌ID',
  idfaSubTitle2Desc1: '1、打开手机【<em>设置</em>】功能；',
  idfaSubTitle2Desc2:
    '2、在【<em>设置</em>】内找到【<em>帐户</em>】或【<em>帐户与同步处理</em>】中的【<em>Google</em>】，点击进入',
  idfaSubTitle2Desc3:
    '3、然后再点击【<em>广告</em>】，即可看到对应的<em>ID</em>（如下图所示）。',
  uploadIDCard: '请提供清晰完整的身份证扫描件，大小不超过20M',
  uploadTipsBefore: '请上传大小',
  uploadTipsAfter: 'M以下的图档',
  submitError: '异常错误，例如身份证号码未填写、用户账号错误都归为异常错误',
  applyLimitError: '超过当日申请限制次数',
  applyDisabled: '提交申请冷却中（只允许10分钟提交一次）',
  inputDataError: '数据未填写完整',
  dataException: '数据异常',
  picSizeLimit: '图档大小限制为5M',
  picTypeLimit: '只能上传JPG，PNG，GIF图档',
  picNull: '图片为空',
  alteredPassword: '已经修改过密码',
  inputError: '输入错误',
  pwdChangefailed: '密码修改失败',
  sendEmailCodeDisabled: '邮箱验证码发送冷却中',
  alteredEmail: '已经修改过邮箱',
  inputEmailError: '邮箱输入错误',
  operationFailed: '操作失败',
  codeNull: '您还未输入验证码',
  findPwd: '密码找回',
  findAccountAndPwd: '找回账号与密码',
  usualDeviceNum: '常用设备号：IDFA/GPID',
  usualPhoneNum: '常用手机型号',
  registerTimeError: '注册时间不符；',
  bindEMailError: '绑定邮箱不符；',
  rechargeRecordError: '储值记录不符；',
  registerIPError: '账号注册IP地址不符；',
  deviceNumError: '常用设备号不符；',
  deviceModelError: '常用手机型号不符；',
  confirmTerms: '请同意服务条款',
  applyFixAccount: '若上述方式无法验证，您可以申请<span>帐号修复</span>;',
  findPwdByFixAccount:
    '该账号没有设置邮箱与密保，您可以通过账号修复功能进行密码找回',
  connectFail: 'Google 服务已断开，请重试',
  h5_favour_has_gift: '收藏游戏至浏览器方便下次再来~您已获得过奖励哦~',
  h5_favour_get_gift: '收藏游戏至浏览器方便下次再来，奖励已发送至您的邮箱~',
  h5_get_gift_fault: '领取失败，请稍后再试或前往游戏内联系客服处理',
  h5_favour_please_select: '请先选择伺服器/角色',
  h5_favour_login_get: '请先进入再收藏，确保奖励发放至您的邮箱哦~',
  h5_favour_tip: '收藏游戏至浏览器方便下次再来～',
  h5_favour_select_serve: '请选择伺服器',
  h5_favour_select_role: '请选择角色',
  store_product_paytype_error:
    '您选择的商品在当前渠道无法进行购买，请更换支付渠道进行购买',
  SwitchWithThirdWay: '切换${type}登录',
  moreGame: '更多游戏',
  serviceTitle: '客服工单',
  h5_download_login: '请先进入游戏再下载，确保奖励发放至您的邮箱哦~',
  h5_download_tips: 'Please start the game from the client.',
  h5_download_repeat_get: '保存到桌面方便下次再来~您已获得过奖励哦~',
  h5_download_succ: '保存到桌面方便下次再来，奖励已发送至您的邮箱~',
  h5_download_repeat_role: '当前角色已被绑定',
  currentLoginAccount: '当前登录账号：',
  fb_canvas_fullscreen: '全屏模式',
  fb_canvas_website: '官网',
  fb_canvas_like_share: '点赞分享',
  fb_canvas_service: '客服',
  fb_canvas_login_fail: '登录失败',
  fb_canvas_pay_return: '您取消了本次交易',
  fb_canvas_root_tip: '请先进行Facebook的授权登录',
  h5_popup_title: '付款方式',
  h5_popup_submit: '付款',
  h5_popup_last_used: '上次使用',
  h5_popup_quit_tips: '是否确认取消付款？',
  h5_popup_quit_check: '是',
  h5_popup_quit_cancel: '否',
  h5_popup_currency_sign: '元',
  h5_popup_product_empty: '未获取到所选商品信息，请刷新页面',
  h5_popup_server_empty: '未获取到服务器列表，请刷新页面',
  aboutRelevanceAccount: '关于关联账户',
  selectLoginType: '请选择登录方式',
  touristDescription:
    'If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.',
  touristSuggest:
    'If you already have an account, you can log in as a guest and then tap the "Switch Account" option in the user center. From there, you can log in using a previously bound social media account.',
  h5_tourist_remenber: '14天内记住我的密码',
  account_czsm1:
    '1. 此操作可以将账号信息继承到新的机器中，不同系统的机器也可以进行该操作；',
  account_czsm2: '2. 进行继承操作时请设置继承用的密码；',
  account_czsm3: '3.为了保障您的账号安全，请',
  account_wzfdmm: '请输入6-16字符的密码，区分大小写',
  account_qzcsrmm: '请再次输入密码',
  account_fxyjm: '发行引继码',
  account_yjmsm1:
    '1. 点击主界面的【用户中心】按钮，在【切换账号】页面内进行账号继承操作；',
  account_yjmsm2: '2. 引继码不会因为时间而过期；',
  account_yjmsm3: '3. 引继码只能使用1次，使用后该引继码则失效；',
  account_yjmsm4: '4. 为了您的账号安全，请勿将引继码相关信息告知他人。',
  account_fz: '复制',
  account_cxfx: '重新发行',
  account_czsm4: '账号绑定',
  account_czsm5: '在继承前',
  account_yjm: '引继码',
  account_16wzzj: '密码的长度在6-16文字之间',
  account_qsrzqdyjmhmm: '请输入正确的引继码和密码',
  account_yj: '引继',
  accoun_lcsrdmmbyz: '两次输入的密码不一致',
  deleteaccount_step3_1: '，取消账号删除的请求，您是否要取消此次申请？',
  account_syyjm: '1.使用引继码，将游戏数据继承到这台设备。',
  account_yjmznsyyc: '2.引继码只能使用一次，可以多次发行。',
  account_sryjm: '输入引继码',
  account_srmm: '输入密码',
  h5_header_gift: '礼包',
  h5_award_popup_type: '奖励',
  h5_award_popup_content: '物品',
  h5_award_popup_code: '礼包兑换码',
  h5_favour_gift_name: '收藏礼包',
  h5_download_gift_name: '下载礼包',
  h5_award_popup_exchange_way: '兑换地址：游戏主界面右下方→更多→礼包码兑换',
  h5_succ_get_gift: '恭喜获得礼包兑换码',
  h5_exchange_info_title: '兑换说明',
  h5_exchange_info_1: '兑换地址：游戏主界面右下方→更多→礼包码兑换',
  h5_exchange_info_2: '一个账号只能兑换一次下载礼包',
  h5_check_gift: '查詢獎勵',
  account_delete_scdqzh: '您确认要删除当前账号以及游戏内所有信息吗？',
  account_delete_fwq: '服务器',
  account_delete_zhm: '角色名',
  account_delete_jshflj: '角色恢复链接',
  account_delete_qzyzmdxx: '（请注意字母大小写）',
  account_delete_jtbcysxx: '建议截图保存以上信息以便账号找回！！！！',
  deleteaccount_step3_2:
    '14天后您的账号会被系统自动删除并且没有任何方式可以进行恢复，您账号内的所有资料将不再存在与保存。\\n\\n在申请后的14天内，您依旧可以通过访问',
  h5_guest_login: 'Guest',
  h5_click_copy: '点击复制',
  questionnaire_btn: '问卷调查',
  h5_header_store_text: '储值',
  h5_header_home_text: '主页',
  h5_check_gift_list_text: '查看奖励',
  yourServer: '您的伺服器',
  allServer: '全部伺服器',
  h5_header_screen: '全屏幕',
  h5_verticalTip: '请用横屏方式进行操作',
  h5_third_party_login_tips:
    'If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.',
  webStoreUidTitle: '账号uid',
  webStoreUidTips: '请确认您的角色信息是否正确',
  webStoreUidGuide: '如果获取UID？',
  webStoreUidInputt: '请输入uid',
  feedbackTips: '',
  recentPlay: '最近在玩',
  moreGames: '更多游戏',
  previousSelect: '上次选择',
  payAgainBtn: '再储一次',
  packageTypeName: '礼包',
  coinTypeName: '储值',
  cardTypeName: '月卡',
  orderNormal: '默认排序',
  orderPriceUp: '按价格升序',
  orderPriceDown: '按价格降序',
  returnSelectRole: '返回重新选择',
  jiamaInfo:
    '加码元宝/钻石说明：</br>加码元宝/钻石=付款金额*游戏 元宝/钻石 比例*加码比例</br>*注意：加码的元宝/钻石，不参与游戏内储值活动的计算，也不計入VIP經驗</br>*部分游戏为全球发行游戏，付款金额将以美金计算，如有问题请联系客服',
  lastSelectTag: '上次选择',
  onestore_subscribe_manage: '管理订阅',
  onestore_subscribe_entrance: 'OneStore订阅管理',
  onestore_subscribe_has_expire: '已到期',
  onestore_subscribe_expire_time: '到期时间： ${year}年${month}月${day}日',
  onestore_subscribe_privacy: '关于订阅和隐私',
  onestore_subscribe_cancel_subscribe: '取消订阅',
  onestore_subscribe_info_title: '订阅信息',
  onestore_subscribe_option_title: '订阅选项',
  onestore_subscribe_do_not_subscribe: '当前角色未购买订阅服务',
  onestore_subscribe_get_role_fail: '获取订阅信息失败，请从游戏内重新进入',
  onestore_subscribe_later: '以后再说',
  onestore_subscribe_confirm: '确认',
  onestore_subscribe_confirm_cancel: '确认取消订阅',
  onestore_subscribe_popup_tip:
    '如果现在确认并结束订阅，您仍可在${year}年${month}月${day}日前继续使用此订阅。',
  onestore_subscribe_detail_tip:
    '商品将于${year}年${month}月${day}日，以${prices}/月的价格自动续期，除非您在续期日期前至少一天取消。',
  onestore_subscribe_expired_tip: '已到期的订阅请在游戏内商城重新选择订阅。',
  onestore_subscribe_goon_sub: '${year}年${month}月${day}日 续期',
  onestore_subscribe_has_cancel_tip1:
    '您已取消订阅，在${year}年${month}月${day}日前，您仍可以继续使用该订阅。',
  onestore_subscribe_has_cancel_tip2:
    '如果您希望恢复订阅，请在游戏内商城重新订阅商品。',
  onestore_subscribe_cancel_fail: '取消订阅失败，请稍候再试',
  onestore_subscribe_cancel_fail_title: '取消订阅',
  apple_deleteaccount: '账号删除',
  apple_deleteaccount_title: '账号删除申请',
  apple_deleteaccount_step1_1: '请仔细阅读以下内容：',
  apple_deleteaccount_step1_2: '在您执行账号删除后，您的账号会被冻结14日。',
  apple_deleteaccount_step1_3:
    '14日后若您不取消账号删除，我们会为您<span class="highlight">永久删除</span>该账号，永久删除后，您无法使用该账号登录游戏，所有资料全部清除且无法恢复。',
  apple_deleteaccount_step1_4:
    '如需解绑对应已绑定的社交网络账号，请提前联系客服解绑完毕再进行账号删除。否则账号删除后，您对应绑定的社交网络账号也无法登录。',
  apple_deleteaccount_step1_5:
    '<span class="highlight">如需退款也请在执行删除前联系客服处理</span>，在执行账号删除前，请确定您的游戏内资产已处理完毕。',
  apple_deleteaccount_step1_6:
    '在冻结期间，您可以通过以下链接取消账号删除的请求，请提前复制保存该地址以便找回。',
  apple_deleteaccount_step2_1:
    '您游戏内资产是否已经处理完毕？如未处理完毕，请联系客服处理后再申请账号删除。',
  apple_deleteaccount_step2_2:
    '请保存您的服务器与角色信息，这是您恢复账号的唯一凭证：',
  apple_deleteaccount_step2_3: '请在输入框中输入“Delete”来完成删除操作',
  apple_deleteaccount_step3_1: '您的账号删除申请已提交，以下账号已被冻结：',
  apple_deleteaccount_step3_2:
    '冻结时间14天，若未收到您的取消删除账号请求，我们会永久删除该账号。',
  apple_deleteaccount_step3_3: '在14天内，您仍旧可以访问以下地址取消删除账号',
  apple_deleteaccount_step4_1: '您已删除老账号，下次进入将使用新账号登录',
  apple_deleteaccount_agree: '我已阅读并同意以上内容',
  apple_deleteaccount_server: '服务器',
  apple_deleteaccount_roleName: '角色名',
  copyLink: '复制链接',
  copyTextAndImg: '请复制或截图保存',
  copyLinkAndRoleInfo: '复制链接和角色名',
  hasCopy: '已复制至剪贴板',
  quickcard_tips:
    '信用卡信息已加密储存并受World Pay保护，此信息只用于优化储值体验。',
  quickcard_use_new_card: '使用新的信用卡',
  edit: '编辑',
  save: '保存',
  quickcard_confirm_delete: '确认删除',
  quickcard_popup_tip:
    '删除后，若您希望再次使用该信用卡，请选择“使用新的信用卡”。',
  quickcard_result_tip_one:
    '如您在刚才的支付页面中选择了储存卡号，我们会收集您的信用卡数据以加密形式进行储存 (**** **** **** 1234）。',
  quickcard_result_tip_two:
    '我们储存加密的信息只是为了方便您的储值体验，您不必在下次购买时输入卡号。',
  quickcard_learn_more: '了解更多细节》',
  quickcard_info_title: '存储凭据说明',
  quickcard_info_tip_one:
    '为了更好地保护客户数据安全， Visa 和 Mastercard 引入了新的“存储凭据”技术，并规范化了存储凭据和相关的交易。',
  quickcard_info_tip_two:
    '当您在我们的网站上购物时，我们会以加密版本收集您的信用卡数据(1234 **** **** 1234）。我们将保留此加密数据4 年，如有任何相关变更，我们将在我们的网站上更新用户条款与隐私政策。我们储存加密信用卡数据只是为了优化您的支付体验，您不必在下次购买时输入卡号。',
  search_product: '搜索商品名',
  search_price: '搜索价格',
  price: '价格',
  product_no_found: '抱歉，我們沒有找到符合的商品名',
  price_no_found: '抱歉，我们没有找到符合的价格',
  search_no_found: '抱歉，我们没有找到符合的商品名/价格',
  product: '商品名称',
  store_tag_hot: 'HOT',
  store_tag_discount: 'Discount',
  store_tag_double: 'Double',
  store_tag_treble: 'Treble',
  store_tag_sale: 'SALE',
  store_tag_top_seller: 'TOP SELLER',
  store_tag_off_10: '10%OFF',
  store_tag_off_20: '20%OFF',
  store_tag_off_30: '30%OFF',
  store_tag_off_40: '40%OFF',
  store_tag_off_50: '50%OFF',
  store_tag_off_60: '60%OFF',
  store_tag_off_70: '70%OFF',
  store_tag_off_80: '80%OFF',
  store_tag_off_90: '90%OFF',
  store_tag_event: 'Event',
  store_tag_daily: 'Daily',
  store_tag_weekly: 'Weekly',
  store_tag_monthly: 'Monthly',
  subscriptionTypeName: '订阅',
  useDoubleSend: '使用礼包翻倍券?',
  doubleSendInfo:
    '由于您在本次购买时，使用了礼包翻倍券，有部分物品可以获得双倍，已在邮件最后单独列出！',
  storeRoleTitle: '请选择要储值的角色',
  storeSocialLogin: '使用社交帐号登录',
  storeAccountIdLogin: '使用账号ID登录',
  storeInputId: '请输入账号ID',
  storeSearch: '查询',
  storeSelectProductTitle: '请选择要购买的道具',
  storeInputNameSearch: '输入商品名进行搜索',
  storeInputPriceSearch: '输入商品价格进行搜索',
  storeNoFindProduct: '找不到商品，请重新搜索。',
  storePriceUp: '按价格升序',
  storePriceDown: '按价格降序',
  storeLookDetail: '查看详情',
  storeChangeProduct: '更换商品',
  storeWelcome: '欢迎',
  storeLookMore: '查看更多',
  storeHasSelect: '已选商品',
  storeTotal: '共',
  storeExtra: '额外赠送',
  storeProductDetail: '商品详情',
  storeUidGuideStep1: '点击「设置」-「更多」-「账户」',
  storeUidGuideStep2: '输入这里的「账号ID」即可储值',
  storeSelectAndLook: '请先选择角色以查看商品',
  storeSwitchWay: '切换登录方式',
  type1: '每日特惠',
  type2: '英雄',
  type3: '战斗装备',
  type4: '',
  type5: '芯片',
  type6: '生化人',
  type7: '资源',
  type8: '建造加速',
  type9: '稀缺商品',
  type10: '联盟',
  type11: '钻石',
  type12: '元件',
  type13: '魔方',
  type14: '',
  type15: '纳米武器',
  type16: '终极大奖',
  type17: '',
  type9999: '限量供应',
  type10000: '福利中心',
  type10001: '节日活动',
  typeother: '其他商品',
  switchChar: '切换角色',
  howToFindUid: '如何找到我的账号ID？',
  choosePayWay: '请选择支付方式',
  new_apple_deleteaccount_stepsub_title: '取消自动续费订阅',
  new_apple_deleteaccount_stepsub_1:
    '系统检测到您的账号有自动续订订阅的付费项目，为避免您在删除账号后继续扣费，建议先取消订阅后再进行账号删除。',
  new_apple_deleteaccount_stepsub_2: '去取消自动续订订阅',
  new_apple_deleteaccount_stepsub_later: '稍后删除',
  new_apple_deleteaccount_stepsub_now: '立即删除',
  new_apple_deleteaccount_title: '账号删除申请',
  new_apple_deleteaccount_step1_1: '请仔细阅读以下内容：',
  new_apple_deleteaccount_step1_2:
    '在您执行账号删除后，我们会为您<span class="highlight">永久删除</span>该账号，永久删除后，您无法使用该账号登录游戏，您的账号关联<span class="highlight">用户资料</span>（包括但不限于游戏货币，道具等资料）将被立即清除且无法恢复。（如您所在国家或地区有相关法律规定要求，则不在此列）',
  new_apple_deleteaccount_step1_3:
    '如需解绑对应已绑定的社交网络账号，请提前联系客服解绑完毕再进行账号删除。否则账号删除后，您对应绑定的社交网络账号也无法登录。',
  new_apple_deleteaccount_step1_4:
    '<span class="highlight">如需退款也请在执行删除前联系客服处理</span>，在执行账号删除前，请确定您的游戏内资产已处理完毕。',
  new_apple_deleteaccount_step2_1:
    '您游戏内资产是否已经处理完毕？如未处理完毕，请联系客服处理后再申请账号删除。',
  new_apple_deleteaccount_step2_2:
    '请在输入框中输入“Delete”来完成删除操作。提交申请后，您的账号将无法恢复。',
  new_apple_deleteaccount_step2_3: '请在输入框中输入“Delete”来完成删除操作',
  new_apple_deleteaccount_step3_1:
    '您的账号删除申请已提交，以下账号及对应用户资料已被彻底删除，不可恢复：',
  new_apple_deleteaccount_step3_2: '如您仍需登录游戏，请重新注册账号。',
  new_apple_deleteaccount_step4_1: '您已删除老账号，下次进入将使用新账号登录',
  currencyTypeName: '代币',
  has_select_product: '已选择商品：',
  n_product: '${n}个商品',
  look_detail_product: '查看全部',
  limit_buy_product: '该商品限购${n}件',
  limit_order: '单笔订单最多支持${n}件商品',
  limit_order_remove_tip: '订单中包含无法购买的限购商品，是否移出购物车？',
  paytype_limit:
    '部分商品不支持该支付方式，请选择其他支付方式 或 尝试单独购买商品',
  check_remove_cart: '是否移出购物车',
  remove_cart: '移出',
  confirm_product: '确认商品',
  select_paytype: '选择支付方式',
  cart_is_empty_tip: '购物车为空，请先选择商品',
  thirty_tip: '若30分钟后仍未收到商品，请联系客服。',
  total_n_product: '共${n}个商品',
  look_detail_of_cart: '查看详细',
  order_detail: '储值商品订单记录',
  total_detail: '数量：',
  add_to_cart: '添加购物车',
  back_to_select: '返回重新选择',
  fail_and_later: '商品信息错误，请稍候再试',
  nextStep: '下一步',
  pnsGameName: 'Puzzles & Survival',
  enterOfficial: '进入官网',
  visitorLogin: '游客登录',
  tokenLogin: '动态令牌',
  fbLogin: 'Facebook登录',
  googleLogin: 'Google登录',
  twitterLogin: 'Twitter登录',
  vkLogin: 'VK登录',
  agreementTextStart: '登录游戏即代表您已完整阅读并同意 账号条款 和 隐私协议',
  userCenter: '用户中心',
  welcomeBack: '欢迎回来',
  continueGame: '继续游戏',
  officialPay: '官方储值中心',
  changeAccount: '切换账号',
  back: '返回',
  tokenKey: '动态令牌',
  inputUid: '请输入UID',
  inputToken: '请输入动态令牌',
  inputCkCode: '请输入验证码',
  enterGame: '进入游戏',
  tokenTip: '使用动态令牌保护您的账号安全',
  howToGetToken: '如何获取我的动态令牌？',
  getStep1: 'Step1:点击设置-账户-用户中心',
  getStep2: 'Step2:点击动态令牌',
  getStep3: 'Step3:复制并输入您的UID和动态令牌',
  copy: '复制',
  lastRefresh: '下次刷新：',
  second: 's',
  immediatelyRefresh: '立即刷新',
  frequently: '频繁过于操作，请稍候再试',
  loginFail: '登录失败，验证码错误',
  tokenIntro: '动态令牌使用说明：',
  tokenIntro1: '（1）动态令牌自刷新起120s内有效，可用于保护您的帐号安全。',
  tokenIntro2:
    '（2）官方人员不会要求您提供动态令牌，请注意不要泄漏您的动态令牌给其他人。',
  nextStep1: '下一步',
  couponCanUse: '可用优惠券',
  couponCanNotUse: '不可用优惠券',
  couponHasNoCoupon: '暂无优惠券',
  couponUseTip: '*每笔订单限用一张',
  couponValidTime: '有效时间',
  couponFuilCanUse: '满 ${price} ${currency} 可用',
  couponNoLimit: '无使用门槛',
  couponAllProductCanUse: '所有商品可用',
  couponPartProductCanUse: '部分商品可用',
  couponPartPaytypeCanUse: '部分支付渠道可用',
  couponOnlyCoinCanUse: '仅限游戏币商品可用',
  couponOnlyDiamondCanUse: '仅限钻石商品可用',
  couponOnlyPackageCanUse: '仅限礼包商品可用',
  couponOnlySubCanUse: '仅限订阅商品可用',
  couponOnlyDaibiCanUse: '仅限代金币商品可用',
  couponMaxDiscount: '最高可优惠 ${price} ${currency}',
  couponHasUsed: '已被使用',
  couponReductionType: '满减券',
  couponDiscountType: '折扣券',
  couponUseNow: '立即使用',
  couponHasNoSelect: '未选中优惠券',
  couponHasSelectQuan: '已选择',
  couponSubmitTip: '*提交订单后即消耗优惠券',
  couponCanUseQuan: '可用优惠券',
  couponOrderTotal: '订单金额',
  couponHasDiscount: '已优惠',
  couponPayTotal: '支付金额',
  couponCancel: '取消',
  couponConfirm: '确认',
  uidLoginName: '动态令牌登录',
  uidToken: '动态令牌',
  uidInputUid: '请输入UID',
  uidInputToken: '请输入动态令牌',
  uidInputCode: '请输入验证码',
  uidTipTitle: '使用动态令牌保护您的账号安全',
  uidTipHowToGet: '如何获取我的动态令牌？',
  uidTipStep1: 'Step1:点击设置-账户-用户中心',
  uidTipStep2: 'Step2:点击动态令牌',
  uidTipstep3: 'Step3:复制并输入您的UID和动态令牌',
  uidTipIntro1: '（1）动态令牌自刷新起60s内有效，可用于保护您的帐号安全。',
  uidTipIntro2:
    '（2）官方人员不会要求您提供动态令牌，请注意不要泄漏您的动态令牌给其他人。',
  couponMyQuan: '我的优惠券',
  couponSelectPaytypeTip: '选定支付渠道后确认优惠信息',
  couponSelectCouponTip: '选择优惠券后查看优惠价格',
  couponValidQuanTip: '（${num}张优惠券可用）',
  couponLookCart: '查看购物车',
  couponUnfoldCart: '收起购物车',
  couponCoupon: '优惠券',
  couponNoUse: '未使用',
  couponSelect: '选择优惠券',
  couponSureUse: '确认使用',
  couponReturn: '返回',
  couponInvalidTime: '失效时间',
  couponBuyNow: '立即购买',
  couponAllType: '全部商品',
  ztmslgType1: '每日特惠',
  ztmslgType2: '英雄',
  ztmslgType3: '战斗装备',
  ztmslgType4: '',
  ztmslgType5: '芯片',
  ztmslgType6: '生化人',
  ztmslgType7: '资源',
  ztmslgType8: '建造加速',
  ztmslgType9: '稀缺商品',
  ztmslgType10: '联盟',
  ztmslgType11: '钻石',
  ztmslgType12: '元件',
  ztmslgType13: '魔方',
  ztmslgType14: '',
  ztmslgType15: '纳米武器',
  ztmslgType16: '终极大奖',
  ztmslgType17: '晶核',
  ztmslgType9999: '限量供应',
  ztmslgType10000: '福利中心',
  ztmslgType10001: '节日活动',
  ztmslgTypeother: '其他',
  antslgType1: '每日特惠',
  antslgType2: '特化蚁',
  antslgType3: '装备',
  antslgType5: '基因',
  antslgType6: '蜗牛',
  antslgType7: '资源',
  antslgType8: '建造研发',
  antslgType9: '稀缺商品',
  antslgType10: '联盟',
  antslgType11: '钻石',
  antslgType12: '细胞',
  antslgType13: '图腾',
  antslgType9999: '限量特供',
  antslgTypeother: '其他',
  typeall: '全部商品',
  vipHead: 'VIP积分',
  vipHead213: '大会员中心',
  vipTitle: 'VIP积分活动',
  nowLevel: '当前VIP等级：',
  myVipScore: '我的积分：',
  nextLevelNeed: '（还有 ${num} 积分达到 VIP ${level}）',
  ruleTitle: '活动规则：',
  ztmslgVipRule1: '1.活动时间:2022年9月22日00:00起（UTC)',
  ztmslgVipRule2: '2.参与游戏︰ Puzzles & Survival',
  ztmslgVipRule3: '每种活动奖励仅可领取一次,请及时领取。',
  ztmslgVipRule4: '3.“登录送券”活动︰首次登录充值页面，领取15%OFF优惠券',
  ztmslgVipRule5:
    '4.“VIP积分”活动︰官方支付页面购买商品积分达到对应等级，即可获得等级到达优惠券与每周专属优惠券',
  ztmslgVipRule6: '5.各币种积分比例请见附表1，不足1积分则不计入',
  ztmslgVipRule7: '6.如订单使用优惠券，积分将以实际支付金额计算',
  ztmslgVipRule8: '7.积分有效期为365天，VIP等级根据当前有效积分进行变动',
  ztmslgVipRule9:
    '8.到达VIP等级即可立刻领取首次到达送券&新等级每周送券，后续每周送券于每周六0点（UTC+0）刷新',
  ztmslgVipRule10:
    '9.每周优惠券需登录领取，如错过不进行补发，优惠券奖励将不定期更新',
  ztmslgVipRule11:
    '10.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  ztmslgVipRule12: '11.VIP档位及赠送抵扣券规则如下图∶',
  ztmslgVipRule13: '12.本活动最终解释权归 Puzzles & Survival 运营团队所有。',
  vipLevel: 'VIP等级',
  vipCondition: '达成积分条件',
  firstSend: '首次达成赠送',
  weeklySend: '每周福利送券',
  lastAllCoupon: '上一档位全部优惠券',
  besides: '附表：',
  couponRatio: '各币种VIP积分比例',
  backToPay: '返回储值',
  quanGift: '优惠券福利',
  quanGiftTips: '您有一批新的优惠券，请查收',
  antslgVipRule1: '因功能焕新，原“VIP积分”活动即将下线。',
  antslgVipRule2:
    '原“VIP积分”活动所得优惠券请您及时使用，避免超出优惠券有效期。',
  antslgVipRule3: '下线时间：2024-09-28 00:00:00(UTC)',
  antslgVipRule4: '活动下线后，您可前往大会员中心体验更多权益：',
  antslgVipRule5:
    '完成任务获取积分，使用积分即可兑换优惠券、游戏道具等奖励！还有专属会员权益、积分抽奖等福利活动。',
  antslgVipRule6: '敬请期待。',
  dzgVipRule0: '1.活动时间:2022年9月27日00:00起（UTC)',
  dzgVipRule1: '1.参与游戏︰${gameName}',
  dzgVipRule2: '每种活动奖励仅可领取一次,请及时领取。',
  dzgVipRule3: '3.“登录送券”活动︰首次登录充值页面，领取15%OFF优惠券',
  dzgVipRule4:
    '3.“VIP积分”活动︰官方支付页面购买商品积分达到对应等级，即可获得等级到达优惠券与每周专属优惠券',
  dzgVipRule5: '4各币种积分比例请见附表1，不足1积分则不计入',
  dzgVipRule6: '5.如订单使用优惠券，积分将以实际支付金额计算',
  dzgVipRule7: '6.积分有效期为365天，VIP等级根据当前有效积分进行变动',
  dzgVipRule8:
    '7.到达VIP等级即可立刻领取首次到达送券&新等级每周送券，后续每周送券于每周六0点（UTC+0）刷新',
  dzgVipRule9:
    '8.每周优惠券需登录领取，如错过不进行补发，优惠券奖励将不定期更新',
  dzgVipRule10:
    '9.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  dzgVipRule11: '10.VIP档位及赠送抵扣券规则如下图∶',
  dzgVipRule12: '11.本活动最终解释权归 ${gameName} 运营团队所有。',
  '213dzgVipRule1': '因功能焕新，原“VIP积分”活动即将下线。',
  '213dzgVipRule2':
    '原“VIP积分”活动所得优惠券请您及时使用，避免超出优惠券有效期。',
  '213dzgVipRule3': '下线时间：2024-08-19 08:00:00 (utc)',
  '213dzgVipRule4': '活动下线后，您可前往大会员中心体验更多权益：',
  '213dzgVipRule5':
    '完成任务获取积分，使用积分即可兑换优惠券、游戏道具等奖励！还有专属会员权益、积分抽奖等福利活动。',
  '213dzgVipRule6': '敬请期待。',
  getReward: '专属头像',
  unbindEntry: '账号绑定/解绑',
  unbindApply: '申请解绑',
  unbindConfirmTitle: '是否确认解绑',
  unbindConfirmTip: '您确定解绑第三方账号？有可能导致账号进度丢失',
  unbindConfirm: '是，继续解绑',
  unbindExit: '否，退出',
  unbindSucc: '解绑成功',
  unbindFail: '解绑失败，请联系客服',
  unbindServiceTitle: '请申请人工解绑',
  unbindContact: '联系人工客服',
  unbindServiceTip: '您不符合自动解绑条件，请联系人工客服申请解绑',
  antslgType15: '传承之力',
  shareEventTitle: '邀好友 享好礼',
  shareRule: '活动规则',
  awardBag: '我的奖励背包',
  initiatorText: '我是发起人',
  inviteeText: '我是受邀人',
  createCode: '创建邀请码',
  createCodeTip: '点击生成专属邀请码',
  createLinkTip: '点击生成专属邀请链接',
  copyText: '复制',
  shareCode: '分享邀请码',
  twShare: '',
  fbShare: '',
  dcShare: '',
  seeAward: '查看奖励',
  seeAwardTip:
    '请前往“<span class="see-light">VIP积分</span>”-“<span class="see-light">我的优惠劵</span>”中进行查看并使用',
  inviteReward: '邀请奖励',
  inviteRewardTip: '受邀人累储档位不重置',
  overweightReward: '加码奖励',
  resetTip: '每月最后一天00：00重置（UTC+0）',
  rewardText1: '受邀人累储达9.99USD',
  rewardText2: '受邀人累储达49.99USD',
  rewardText3: '受邀人累储达99.99USD',
  rewardText4: '每邀请5人，获得一张12%OFF优惠劵！',
  rewardText5: '受邀人总充值数达1000USD，获得一张15%OFF优惠劵！',
  invitationList: '邀请一览',
  refresh: '刷新',
  invitedTotal: '总计已邀请：${total} 人',
  storedTotal: '总计已累充：${total} USD',
  people: '',
  invitedPeople: '受邀人',
  invitedTime: '受邀时间',
  got: '已达成',
  get: '未达成',
  overlay: '可叠加',
  couponText: '优惠劵',
  personalReward: '个人储值奖励',
  personalRewardText1: '个人累储达9.99USD',
  personalRewardText2: '个人累储达49.99USD',
  personalRewardText3: '个人累储达99.99USD',
  inputCode: '输入邀请码',
  bindCode: '绑定邀请码',
  bindSucc: '已绑定',
  codeTip1: '邀请码不存在，请重新输入',
  codeTip2: '已绑定邀请码',
  copySucc: '复制成功',
  awardName: '奖励名称',
  getTime: '获得时间',
  getCondition: '获得条件',
  couponText1: '6%off 优惠劵',
  couponText2: '8%off 优惠劵',
  couponText3: '10%off 优惠劵',
  couponText4: '12%off 优惠劵',
  couponText5: '15%off 优惠劵',
  ruleText1: '1.活动时间:2022年11月25日00:00起（UTC)',
  ruleText2: '2.参与游戏︰Puzzles & Survival',
  ruleText3:
    '3.“官方充值分享”活动︰分享并邀请好友使用官方充值页面，充值达指定金额即可领取奖励',
  ruleText4:
    '4.“第三方分享月度奖励”活动︰达成每月分享目标，即可获得对应奖励，奖励每月刷新',
  ruleText5: '5.月度奖励新玩家需邀请后于第三方有进行充值',
  ruleText6: '6.月度奖励每月1日进行更新，前一个月进度也将清空',
  ruleText7: '7.奖励的优惠券需登录第三方支付页面领取，过期不领将不进行补发',
  ruleText8:
    '8.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  ruleText9: '9.双方玩家无法相互绑定对方邀请码',
  ruleTableTitle1: '分享奖励规则如下：',
  ruleTableTitle2: 'VIP档位及赠送抵扣券规则如下图：',
  ruleTableHead1: '充值标准',
  ruleTableHead2: '奖励标准',
  ruleTableHead3: '奖励',
  ruleTableContent1: '邀请新玩家5人',
  ruleTableContent2: '绑定玩家充值金额达1000USD',
  errorTip: '操作失败',
  eventShareText1: '末日喧嚣：末日商城限时优惠活动正在开启中',
  eventShareText2: '海量福利等你来拿',
  cartDoubleTip: '购物车暂不支持使用翻倍券',
  codeTip3: '未登录',
  codeTip4: '缺少参数',
  codeTip5: '不能绑定自己的邀请码',
  codeTip6: '已经生成邀请码',
  payWelfare: '储值福利',
  wallet: '钱包',
  myDiscount: '我的优惠券',
  knowMore: '了解更多',
  backPay: '返回储值',
  curBalance: '当前余额',
  pay: '储值',
  changeCoin: '切换币种',
  watchDesc: '查看详细',
  getMore: '获得更多',
  getDiscount: '领取优惠券',
  notOpenDiscountQuan: '当前未开启优惠券活动，敬请期待',
  abountZbit: '关于${Z-BIT}',
  remain: '剩余：',
  payRemain: '支付后预计剩余',
  payRemainExpiry: '支付后预计余额为${money} （26年1月1日失效，请尽快使用）',
  balanceNotEnoughExpiry: '余额不足（26年1月1日失效，不支持充值）',
  balanceNotEnoggh: '余额不足，请先储值',
  goToPay: '前往储值',
  chooseOtherPay: '选择其他支付方式',
  payIntro: '储值说明',
  logRole: '登入角色',
  chooseProduct: '选择商品',
  meAgree: '我已阅读并同意',
  coinAgreeText:
    '江山美人日语版运营团队可能会提供与您的帐户相关联的帐户余额。交換コイン既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或江山美人日语版运营团队接受的任何其他付款方式将资金存入您的交換コイン，最高金额由江山美人日语版运营团队确定。在任何二十四(24)小时内，存储在您的交換コイン中的总金额加上从您的交換コイン中支出的总金额的总和不得超过5,000美元或以您适用的当地货币表示的等值金额。',
  aboutCoin: '',
  coinsPayTokenLogin: '使用${Z-BIT}前需要进行动态令牌验证',
  dl3dvnVipRule1: '1.参与游戏︰${gameName}',
  dl3dvnVipRule2: '每种活动奖励仅可领取一次,请及时领取。',
  dl3dvnVipRule3: '3.“登录送券”活动︰首次登录充值页面，领取15%OFF优惠券',
  dl3dvnVipRule4:
    '3.“VIP积分”活动︰官方支付页面购买商品积分达到对应等级，即可获得等级到达优惠券与每周专属优惠券',
  dl3dvnVipRule5: '4.各币种积分比例请见附表1，不足1积分则不计入',
  dl3dvnVipRule6: '5.如订单使用优惠券，积分将以实际支付金额计算',
  dl3dvnVipRule7: '6.积分有效期为365天，VIP等级根据当前有效积分进行变动',
  dl3dvnVipRule8:
    '7.到达VIP等级即可立刻领取首次到达送券&新等级每周送券，后续每周送券于每周六0点（UTC+0）刷新',
  dl3dvnVipRule9:
    '8.每周优惠券需登录领取，如错过不进行补发，优惠券奖励将不定期更新',
  dl3dvnVipRule10:
    '9.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  dl3dvnVipRule11: '10.VIP档位及赠送抵扣券规则如下图∶',
  dl3dvnVipRule12: '11.本次活动由泰国支付渠道支持，仅供泰国地区玩家参与',
  dl3dvnVipRule13: '12.本活动最终解释权归 ${gameName} 运营团队所有。',
  codeTip7: '该玩家已经绑定了您的邀请码，您无法再使用他的邀请码进行绑定',
  ruleText10: '10.本活动最终解释权归Puzzles & Survival所有。',
  payCoins: '储值VIP积分',
  shareGift: '分享有礼',
  attentionCoinUse: '注意：不同币种的余额不通用',
  noPayWay: '非常抱歉，您所选的地区暂无可用渠道，请尝试其他地区',
  dl3dtwVipRule1: '1.参与游戏︰${gameName}',
  dl3dtwVipRule2: '每种活动奖励仅可领取一次,请及时领取。',
  dl3dtwVipRule3:
    '2.“VIP积分”活动︰官方支付页面购买商品积分达到对应等级，即可获得等级到达优惠券与每周专属优惠券',
  dl3dtwVipRule4: '3.各币种积分比例请见附表1，不足1积分则不计入',
  dl3dtwVipRule5: '4.如订单使用优惠券，积分将以实际支付金额计算',
  dl3dtwVipRule6: '5.积分有效期为365天，VIP等级根据当前有效积分进行变动',
  dl3dtwVipRule7:
    '6.到达VIP等级即可立刻领取首次到达送券&新等级每周送券，后续每周送券于每周六0点（UTC+0）刷新',
  dl3dtwVipRule8:
    '7.每周优惠券需登录领取，如错过不进行补发，优惠券奖励将不定期更新',
  dl3dtwVipRule9:
    '8.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  dl3dtwVipRule10: '9.VIP档位及赠送抵扣券规则如下图∶',
  dl3dtwVipRule11: '10.本活动最终解释权归 ${gameName} 运营团队所有。',
  eventInviteSucc: '邀请成功',
  eventGainCondition: '获得条件',
  eventSuccInvite: '成功邀请到好友',
  eventInviteGainOne: '受邀人累储达49.99USD',
  eventInviteGainTwo: '受邀人累储达99.99USD',
  eventFriendCode: '您当前拥有的好友邀请码：',
  eventCheckBind: '是否进行绑定？',
  eventConfirm: '确定',
  eventCancel: '取消',
  eventBindSucc: '成功绑定！',
  eventGainCoupon: '恭喜你，获得一张优惠劵！',
  eventLookCoupon: '查看优惠劵',
  eventSuccBind: '成功绑定',
  recaptchaTip: '请先进行验证',
  completeRecaptcha: '请完成人机验证',
  recaptchaExpired: '验证已过期，请重新验证',
  inputAccountName: '请输入要找回的帐号',
  pwaPayTip: '更快的支付，更好的体验',
  pwsInstall: '添加至桌面',
  ztmslgType999: '代金券',
  coinUseTips:
    '代金券将在游戏内以邮件形式发放，可在游戏內的代金券商城购买任意商品，消耗代金券时可获得累计储值奖励',
  notice: '公告',
  popupConfirm: '确认',
  hideWithinWeek: '7天内不再显示',
  ztmslgProductOffTips:
    '近期我们收到了很多热心玩家对即将到来的支付页更新的反馈，我们非常重视玩家的声音。现决定：取消原定于3月13日上线的改动。我们将会继续不断优化您的购物体验，感谢您的理解与支持！如有问题，欢迎咨询客服。',
  couponTopLimit: '各币种优惠金额上限',
  swsjpVipRule1: '1.活动时间:2023年3月24日00:00起（UTC)',
  swsjpVipRule2: '2.参与游戏︰${gameName}',
  swsjpVipRule3: '每种活动奖励仅可领取一次,请及时领取。',
  swsjpVipRule4: '3.“登录送券”活动︰首次登录充值页面，领取15%OFF优惠券',
  swsjpVipRule5:
    '4.“VIP积分”活动︰官方支付页面购买商品积分达到对应等级，即可获得等级到达优惠券与每周专属优惠券',
  swsjpVipRule6: '5.各币种积分比例请见附表1，不足1积分则不计入',
  swsjpVipRule7: '6.如订单使用优惠券，积分将以实际支付金额计算',
  swsjpVipRule8: '7.玩家历史充值已按照一定比例转换为初始积分',
  swsjpVipRule9: '8.积分有效期为365天，VIP等级根据当前有效积分进行变动',
  swsjpVipRule10:
    '9.到达VIP等级即可立刻领取首次到达送券&新等级每周送券，后续每周送券于每周六0点（UTC+0）刷新',
  swsjpVipRule11:
    '10.每周优惠券需登录领取，如错过不进行补发，优惠券奖励将不定期更新',
  swsjpVipRule12:
    '11.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  swsjpVipRule13: '12.本活动最终解释权归${gameName}运营团队所有。',
  beautyVipRule1: '',
  beautyVipRule2: '',
  beautyVipRule3: '',
  beautyVipRule4: '',
  beautyVipRule5: '',
  beautyVipRule6: '',
  beautyVipRule7: '',
  beautyVipRule8: '',
  beautyVipRule9: '',
  beautyVipRule10: '',
  beautyVipRule11: '',
  antslgType999: '代金券',
  passAskMods: '向mod提问',
  passAskModsTip: '关于游戏的疑问，都可以向mod提问',
  passService: '客服咨询',
  passServiceTip: '有关账号、充值等问题，请联系客服',
  passIKonw: '我知道了',
  passGoOn: '继续咨询',
  voucherTitle: '官方储值中心',
  voucherAddHome: '添加至桌面',
  voucherAddHomeTipOne: '更快的支付，更好的体验',
  voucherAddHomeTipTwo: '点击工具栏的【分享】',
  voucherAddHomeTipThree: '并选择【添加至桌面】',
  voucherLoginLook: '登录以查看优惠',
  voucherSwitchRole: '切换角色',
  voucherCoupon: '优惠券',
  voucherVip: 'VIP积分',
  voucherMoreCoupon: '更多优惠',
  voucherAccountId: '帐号ID',
  voucherOtp: '动态令牌',
  voucherOtherWayPay: '使用其他支付方式',
  voucherOtherLoginWay: '使用其他登录方式',
  voucherCouponActivity: '优惠活动',
  voucherActivityNotBegin: '活动未开始，敬请期待',
  voucherGoCommunity: '前往社群了解更多储值福利',
  voucherValidTime: '有效期',
  voucherLimitRegion: '限${currency}使用',
  voucherLiuyi: '无可用优惠券，请留意官方活动信息',
  voucherPay: '购买代金券',
  voucherAbout: '关于代金券',
  voucherChooseWay: '选择支付方式',
  voucherMoreWay: '更多支付方式',
  voucherChooseCoupon: '选择优惠券',
  voucherHasChoose: '已选择',
  voucherMoneyInsufficient: '余额不足',
  voucherContact: '余额不足，请联系客服',
  voucherCouponTotal: '当前可用优惠券数量',
  voucherCouponTipGuide: '选择支付渠道后，在结算时选择优惠券使用',
  voucherPaytypeNotSupport: '当前支付渠道不支持使用优惠券',
  voucherTipSideOne:
    '代金券可用于兑换本游戏中除了代金券以外的所有礼包及增值服务',
  voucherTipSideTwo: '最高享15%优惠',
  voucherYue: '余额',
  jpUidLoginName: '',
  jpUidToken: '',
  jpUidInputToken: '',
  pnsBook: '末世生存手册',
  vipHeadText: '恭喜您已解锁VIP专属头像框',
  vipHeadGetText: '立即领取',
  vipHeadGotText: '已领取',
  vipHeadGetTitle: '确认领取',
  vipHeadGetTip: '每个账号仅能领取一次，是否领取到当前角色',
  vipHeadAwardText: '金牌指挥官（永久）',
  vipHeadGetErrTip1: '领取失败，请稍后再试或联系客服',
  cartGuideTipNew: '多件支付，优惠同享',
  newVipTitle: '官网储值中心专属VIP',
  newVipLogin: '登录',
  newVipNowPoint: '当前积分：',
  newVipNextLevel: '距离下一级还差 ${point} 积分',
  newVipUpgrade: '立即升级',
  newVipLevel: 'VIP等级福利',
  newVipTip: '优惠券奖励将于每周六UTC 0点刷新，登录官网储值页面时自动发放。',
  newVipWeekly: '每周赠送',
  newVipReachPoint: '达成要求：',
  newVipRuleInfo: '规则说明：',
  pleaseLang: '请选择语言',
  reference: '订单号',
  saveToNext: '保存以便下次支付使用',
  cardNum: '卡号',
  expireTime: '有效期',
  CVV: '安全码',
  pleaseCard: '选择信用卡卡种',
  howToPay: '您打算如何付款？',
  checkCard: '请检查卡号',
  checkExpiryDate: '请检查有效期',
  checkCVV: '请检查安全码',
  addCard: '新增',
  delete: '删除',
  deleteCardTips: '删除存储的信用卡资料',
  confirmDelete: '是，删除',
  cancelDelete: '取消',
  checkAllCardMsg: '请检查卡号、有效期、安全码是否正确',
  leaveCreditPageTips: '离开页面会导致订单支付失败，是否确认离开',
  sureToLeave: '确认离开',
  continueToPay: '继续支付',
  pushTest: '推送测试',
  getNoticication: '设备收不到游戏推送通知？',
  waitCheckResult: '请耐心等待检测结果，以定位原因~',
  hadAbnormal: '存在检测项异常，导致可能收不到推送。',
  clickIntro: '请点击异常项查看解决指引',
  networkCheck: '网络环境检测',
  noticeAuthorityCheck: '通知权限检测',
  noticeBtnCheck: '通知栏开关检测',
  gmsCheck: 'GMS服务检测',
  batteryCheck: '电池优化列表检测',
  pushServiceCheck: '推送服务检测',
  reCheck: '重新检测',
  noNoticeAuthorityTip:
    '设备未授予游戏通知权限，请前往系统设置-通知，选择游戏并打开通知权限。',
  noNoticeBtnTip:
    '游戏的通知栏开关未打开，请前往系统设置打开游戏的通知栏开关。',
  noBatteryTip:
    '游戏在设备的电池优化列表，可能收不到推送。请前往系统设置-电池-电池优化，将游戏加入白名单。',
  noPushServiceTip: '推送服务连接失败，请点击【连接】按钮进行服务器连接',
  noNetworkTip: '当前网络环境异常，请连接稳定的网络后再重试',
  noGmsTip:
    '该设备不支持GMS谷歌移动服务，请更换支持GMS服务的设备登录以接收通知',
  pushConnectFail: '推送服务连接失败',
  pushConnectSucc: '推送服务连接成功',
  noGetPushTitle: '如果仍收不到游戏推送，请按以下步骤检查：',
  noGetPushContOne: '1、在当前设备退出游戏后重新登录游戏账号；',
  noGetPushContTwo:
    '2、点击【推送测试】，将自动下发测试，请留意当前设备是否能接收到；',
  noGetPushContThree:
    '3、若设备能接收到测试推送，但收不到游戏内推送，请前往游戏-设置-通知，检查游戏内相关通知项是否已打开；',
  noGetPushContFour: '4、若按以上操作仍收不到推送，请联系客服协助处理。',
  getPushSucc: '设备已成功接收上一条测试推送，推送功能正常！',
  allCheckSucc: '所有检测项正常！',
  pushCheck: '推送检测',
  useDirectPay: '使用快捷支付',
  paypalFraudnetInfo: '支付信息受Paypal风控引擎保护',
  goToSetting: '前往设置',
  retry: '重试',
  connect: '连接',
  canRebind: '解绑后，您可以重新进行绑定',
  agreePlatform: '我已同意${service}和${privite}',
  sendGameNews: '订阅游戏最新资讯',
  canNotBindEmail: '解绑后，将无法使用该邮箱进行登录',
  canNotBindPhone: '解绑后，将无法使用该手机号码进行登录',
  canChangeByEmail: '通过邮箱可以在不同设备切换登录',
  canChangeByPhone: '通过电话号码可以在不同设备切换登录',
  loginSucc: '登录成功',
  phoneHadBind: '该手机号账号已被绑定，是否直接登录',
  emailHadBind: '该邮箱账号已被绑定，是否直接登录',
  phoneNotBind: '该手机号账号未绑定，是否创建新账号',
  emailNotBind: '该邮箱帐号未绑定，是否创建新账号',
  emailAccount: '邮箱账号',
  phoneAccount: '手机号帐号',
  phoneInputError: '手机号码格式错误',
  registerNewAccount: '注册新账号',
  secureTip: '关于代储及账号安全提示',
  toTop: '置顶',
  createNewWork: '创建新的工单',
  serviceEvaluate: '客服评价',
  emailRemind: '邮箱提醒',
  isAgreeService: '您对我们的服务满意吗？',
  thankEvaluateTop: '感谢您宝贵的评价！',
  inputValidEmail: '请输入有效邮箱地址',
  replyWillRemind:
    '客服回复后，您的邮箱会收到提醒邮件。若要取消此功能请再次点击邮箱提醒功能即可。',
  isCancelEmailRemind: '是否取消邮箱提醒？取消后将无法接收提醒邮件哦～',
  reconfirmEmail: '请您确认邮箱是否正确',
  confirmCanSubmit: '确认后可提交工单',
  serviceWillReply: '客服回复后会通过邮箱提醒',
  cancelEmailRemind: '您是否要取消【邮箱提醒】？',
  yes: '是',
  no: '否',
  inputWorkSearch: '请输入搜索关键字',
  loading: '加载中',
  loadingError: '加载失败，请点击重新加载...',
  noMore: '没有更多了',
  cancelToTop: '取消置顶',
  evaluateOne: '很不满意',
  evaluateTwo: '不满意',
  evaluateThree: '一般',
  evaluateFour: '满意',
  evaluateFive: '很满意',
  confirmDelWorkTop: '确认删除此工单？',
  reRemindEmail: '想再次通过邮件提醒您？您可重新点击【邮箱提醒】。',
  confirmWillReply: '确认后，客服回复后会通过邮箱提醒',
  thankEvaluateBottom: '您的评价是提升我们服务质量的动力！',
  confirmDelWorkBottom: '删除后不可回复哦～',
  morePurchaseWay: '更多储值方式',
  purchaseNeed: '购买商品需要：',
  videoUploadSucc: '视频上传成功',
  videoUploadFail: '视频上传失败',
  videoUploadLimit:
    '只能上传mp4格式的视频，视频大小不能超过400Mb，视频时长不能超过2分钟。',
  imageUploadSucc: '图片上传成功',
  imageUploadFail: '图片上传失败',
  uploading: '上传中',
  smartOrderCreate: '快速创建工单',
  smartOrderSearch: '搜索',
  smartOrderComing: '敬请期待',
  smartOrderContactService: '联系客服',
  smartOrderDetector: '诊断助手',
  smartOrderDetect: '诊断',
  smartOrderDetecting: '诊断中',
  smartOrderDetectTip:
    '检测到您游玩过程中游戏遇到问题，请您点击诊断，我们将帮您定为问题。',
  smartOrderDetectTip2: '已经帮您定为问题，提交工单后，我们会帮您解决问题!',
  smartOrderSubmit: '提交',
  smartOrderIKnow: '我知道了',
  smartOrderConfirm: '确定',
  smartOrderLook: '查看',
  smartOrderIsHelp: '这篇文章对您是否有帮助？',
  smartOrderInputQuestion: '请输入您的问题',
  smartOrderPleaseInpt: '请输入',
  smartOrderPleaseChoose: '请选择',
  smartOrderStoreTime: '充值时间',
  smartOrderInputOrder: '请输入订单号',
  smartOrderInputPrice: '请输入订单金额',
  smartOrderNeedHelp: '您好，请问需要什么帮助？',
  smartOrderLookHelpTip: '您可以查看常见问题的解决方法',
  smartOrderNoResult: '暂无搜索结果，请尝试搜索其他内容',
  smartOrderUpdateTime: '最新修改时间',
  smartOrderSelectStoreTime: '请选择充值时间',
  smartOrderAtlestChoose: '请至少填写一项',
  workHomeTitle: '客服中心',
  workHomeCurServer: '当前区服',
  workHomeSearchPlaceholder: '输入关键词，快速查找答案',
  workHomeSelfService: '自助服务',
  workHomeAiService: '智能客服',
  workHomeArtificialService: '人工客服',
  workHomeServiceEntrance: '竭诚为您服务',
  pwaInstallAward: '添加至桌面',
  getMasonry: '领奖钻石',
  addToDrawerVisit: '添加至桌面方便下次访问',
  immeAddToGet: '马上添加，即可领取限时奖励',
  add: '添加',
  talkNextTime: '下次再说',
  chooseRoleGetGift: '选择角色以领取奖励',
  getGiftSuccess: '领取成功，请在游戏内查看奖励',
  dmaTitle: '个性化广告',
  dmaTitleSub: '（可选）',
  newAdd: '新增',
  smartDelete: '删除',
  wordLengthTip: '(0-600字)',
  areaLimitSwitchRegion: '更换地区',
  areaLimitCurrentRegionCurrency: '当前地区和支付币种',
  areaLimitRegion: '地区：',
  areaLimitCurrency: '支付币种：',
  areaLimitNote: '注意：',
  areaLimitSwitchLimitation: '单个账号在每个自然年内仅可切换1次地区',
  areaLimitPostSwitchCoupon:
    '完成切换后，新获得的优惠券将根据新的地区对应币种进行发放。',
  areaLimitRemainingSwitches: '当前剩余次数：${times}',
  areaLimitNoRemainingSwitches: '无剩余次数',
  areaLimitUnableToSwitchThisYear: '今年内无法再次修改',
  areaLimitCannotSwitch: '无法修改',
  areaLimitNavigateToSwitch: '前往修改',
  areaLimitConfirmSwitch: '确认修改',
  areaLimitPreSwitchRegionCurrency: '切换前地区和支付币种',
  areaLimitPostSwitchRegionCurrency: '切换后地区和支付币种',
  areaLimitPostSwitchRestriction: '成功切换后，今年内不可再次切换支付地区。',
  areaLimitUnusedZBitWarning:
    '您还有未使用的Z-Bit，切换地区后可能无法使用Z-Bit，是否继续？',
  areaLimitConfirm: '确认',
  areaLimitCancel: '取消',
  areaLimitInconsistencyWarning: '您的访问地区跟支付地区不一致',
  areaLimitPromptToSwitch: '是否需要更换地区？',
  areaLimitEnterZipCode: '*请输入您的zipcode',
  areaLimitEnterInvalid: 'zipcode无效，请重新输入',
  areaLimitTaxRateTips: '根据你所在的地区，税率可能会有差异，以支付金额为准',
  areaLimitInfoCollect: '信息收集保护请查阅《隐私政策》',
  getAward: '领取奖励',
  selectProductTitle: '选择商品',
  hotSuggest: '热门推荐',
  inputKeywordSearch: '输入关键字搜索',
  lookProductContent: '查看商品内容',
  popupClose: '关闭',
  productSwitch: '更换商品',
  confirmBuy: '确认购买',
  thinkLater: '再想想',
  areaLimitConfirmRegion: '确认地区',
  areaLimitContinuePay: '继续支付',
  areaLimitSwitchLimitationTwice: '单个账号在每个自然年内可切换2次地区',
  dtmslgVipRule1: '1.参与游戏︰${gameName}',
  dtmslgVipRule2: '每种活动奖励仅可领取一次,请及时领取。',
  dtmslgVipRule3:
    '2.“VIP积分”活动︰官方支付页面购买商品积分达到对应等级，即可获得等级到达优惠券与每周专属优惠券',
  dtmslgVipRule4: '3.各币种积分比例请见附表1，不足1积分则不计入',
  dtmslgVipRule5: '4.如订单使用优惠券，积分将以实际支付金额计算',
  dtmslgVipRule6: '5.积分有效期为365天，VIP等级根据当前有效积分进行变动',
  dtmslgVipRule7:
    '6.到达VIP等级即可立刻领取首次到达送券&新等级每周送券，后续每周送券于每周六0点（UTC+0）刷新',
  dtmslgVipRule8:
    '7.每周优惠券需登录领取，如错过不进行补发，优惠券奖励将不定期更新',
  dtmslgVipRule9:
    '8.优惠券币种以您最后充值成功的订单币种为准，如需更换币种请联系客服',
  dtmslgVipRule10: '9.VIP档位及赠送抵扣券规则如下图∶',
  dtmslgVipRule11: '10.本活动最终解释权归 ${gameName} 运营团队所有。',
  dtmslgType10010: '每日特惠',
  dtmslgType10020: '限量供应',
  dtmslgType10030: '英雄',
  dtmslgType10040: '战斗装备',
  dtmslgType10050: '符文',
  dtmslgType10060: '图腾',
  dtmslgType10070: '圣石',
  dtmslgType10080: '巨龙',
  dtmslgType10090: '资源',
  dtmslgType10100: '建造研发',
  dtmslgType10110: '稀缺商品',
  dtmslgType10120: '命运武装',
  dtmslgType10130: '钻石',
  dtmslgType10140: '代金券',
  dtmslgType2: '活动礼包',
  dtmslgType3: '福利中心',
  dtmslgType4: '触发礼包',
  dtmslgType5: '主界面礼包',
  dtmslgType20010: '黑色星期五',
  dtmslgType20021: '五日大礼',
  dtmslgTypeother: '其他',
  rightsIntro:
    '因功能焕新，原“VIP积分”活动已下线，您可前往大会员中心体验全新服务：<br/>\n完成任务获取积分，消耗积分即可兑换优惠券、游戏道具等奖励！<br/>\n还有专属会员权益、积分抽奖等内容，更多奖励、活动敬请期待。',
  '213RightsIntro':
    '因功能焕新，原“VIP 积分”活动即将下线。<br />\n 原“VIP 积分”活动所得优惠券请您及时使用，避免超出优惠券有效期。<br />\n 下线时间：2024-08-19 08:00:00 (utc)<br />\n 活动下线后，您可前往大会员中心体验更多权益：<br />\n 完成任务获取积分，使用积分即可兑换优惠券、游戏道具等奖励！还有专属会员权益、积分抽奖等福利活动。<br />\n 敬请期待。',
  '263RightsIntro':
    '因功能焕新，原“VIP 积分”活动即将下线。<br />\n 原“VIP 积分”活动所得优惠券请您及时使用，避免超出优惠券有效期。<br />\n 下线时间：2024-09-28 00:00:00 (UTC)<br />\n 活动下线后，您可前往大会员中心体验更多权益：<br />\n 完成任务获取积分，使用积分即可兑换优惠券、游戏道具等奖励！还有专属会员权益、积分抽奖等福利活动。<br />\n 敬请期待。',
  goToRights: '前往大会员中心',
  oldVipIntro: '原“VIP积分”活动所得优惠券请您及时使用，避免超出优惠券有效期。',
  'pwa-20001': '请先登录',
  'pwa-20002': '参数错误',
  'pwa-20003': '未绑定角色',
  'pwa-20004': '奖励发放失败，请重试或联系客服',
  'pwa-20005': '您已领取过该礼包',
  'pwa-20100': '活动还未开始',
  'pwa-20101': '活动已结束',
  'pwa-20102': '未到领奖时间',
  'pwa-20103': '领奖时间已结束',
  'pwa-1001': '频繁操作',
  pwaCommon: '请稍后再试',
  zipCodeSwitchZipCode: 'Switch ZIP Code',
  zipCodeState: 'state',
  zipCodeRate: 'rate',
  '-': '-',
  officialStore: '官网储值中心',
  headerSafeTip: '安全无风险 极速到账',
  safeChecking: '…正在检测当前支付环境',
  safeChecked: '安全，可放心使用',
  riskChecked: '存在风险，请谨慎操作',
  footerSafeTitle1: '安全',
  footerSafeTitle2: '便捷',
  footerSafeTitle3: '实惠',
  footerSafeTitle4: '高效',
  footerSafeContent1: '官方储值中心',
  footerSafeContent2: '支持超多支付方式',
  footerSafeContent3: '优惠折扣，更多限时福利',
  footerSafeContent4: '极速到帐，无延迟',
  limitedTimeActivityTitle: '限时福利',
  limitedTimeActivityTime: '活动时间： ${startDate} - ${endDate}（UTC）',
  limitedTimeActivityTaskProcess: '(当前 ${curPay}/${targetPay})',
  limitedTimeActivityRateTips: '（汇率有一定变动，请以此页面展示为准）',
  limitedTimeActivityNotAchieve: '未完成',
  limitedTimeActivityClaim: '领取',
  limitedTimeActivityClaimed: '已领取',
  limitedTimeActivityTimeLeft: '限时： ${days}d ${hours}:${minutes}:${seconds}',
  limitedTimeActivityRecord: '领取记录',
  limitedTimeActivityAward: '奖励',
  limitedTimeActivityGotTime: '领取时间',
  limitedTimeActivityGotRole: '领取角色',
  limitedTimeActivityRule: '活动规则',
  limitedTimeActivity285Rule1: '1.活动时间：  ${startDate} - ${endDate}（UTC）',
  limitedTimeActivity285Rule2:
    '2.活动时间内，完成限时任务即可领取奖励，任务分类每周任务以及每月任务：',
  limitedTimeActivity285Rule3:
    '（1）每周任务：每个帐号限定完成一次，每周一0点重置',
  limitedTimeActivity285Rule4:
    '每周登录任务：限定时间内，完成一次登录官网储值页面；',
  limitedTimeActivity285Rule5:
    '完成一次任意金额储值：限定时间内，在官网储值页面上，完成一笔储值，任意金额均可完成任务。',
  limitedTimeActivity285Rule6:
    '（2）每月任务：每个帐号限定完成一次，每月1号0点',
  limitedTimeActivity285Rule7:
    '登录任务：限定时间内，完成一次登录官网储值页面；',
  limitedTimeActivity285Rule8:
    '累计储值任务：限定时间内，在官网储值页面上，累计储值达到任务档位，即可领取一次奖励',
  limitedTimeActivity285Rule9:
    '注意：由于活动时间持续较长，汇率可能会有变动，储值金额请以页面展示为准',
  limitedTimeActivity285Rule10:
    '3.领取奖励前，需要先选择一个角色进行领取，领取后请在游戏内查看奖励',
  limitedTimeActivityClaimAward: '领取奖励',
  limitedTimeActivityConfirmGot: '确认领取',
  limitedTimeActivityGetSucc: '领取成功',
  limitedTimeActivityGetFail: '领取失败，请稍后再试或联系客服',
  limitedTimeActivityFrequent: '请勿频繁操作',
  limitedTimeActivityLoginFirst: '请先登录',
  limitedTimeActivityWrongParam: '参数错误',
  limitedTimeActivityOverTips: '活动已过期，请刷新页面',
  preRightsIntro:
    '因功能焕新，原“VIP 积分”活动即将下线。<br /> 下线时间：${offLineDate}<br />原“VIP 积分”活动所得优惠券请您及时使用，避免超出优惠券有效期。<br /> 活动下线后，您可前往大会员中心体验更多权益：<br />完成任务获取积分，使用积分即可兑换优惠券、游戏道具等奖励！还有专属会员权益、积分抽奖等福利活动。<br />敬请期待。',
  riskTipTitle: '警惕违规不良行为及诈骗风险',
  riskTipContent:
    '亲爱的玩家，\n\n为营造公平有序，健康多元的游戏环境，我们建议诸位玩家警惕以下破坏游戏秩序及公平性的违规不良行为，常见的有：\n\n1. 发布违规广告：通过聊天等渠道发布违规广告，如非法资源交易、非法代充等；\n2. 使用外挂或脚本：在游戏内使用外挂或脚本等技术手段进行违规批量获得资源；\n3. 违规邀请：聊天时发送与游戏内容无关的违规邀请，诱导通过游戏外渠道(如Line、Discord)进行联系；\n4. 非法代充：以低价充值折扣为诱饵，引导玩家进行非官方充值；\n5. 其他形式诈骗，如冒充官方人员等。\n\n我们希望提醒各位玩家，请各位保护好财产和个人信息，切勿相信任何违规及诈骗信息。以上违规行为存在诸多风险，不仅可能会使您面临账号被盗用的风险，且可能涉及欺诈行为，对于涉及违规行为所导致的损失，我们不支持给予任何的补偿。\n\n对于违规的账号，我们会视违规情况严重程度及影响范围采取行动，包括但不限于警告、扣除非法收益、暂时或永久封禁游戏账号等措施。如果您在游戏中遇到任何可疑行为，可以通过联系客服向我们举报。我们会尽快确认并及时采取措施，感谢您的理解与支持。',
  linkValid: '该链接已失效',
  accountLabel: '帐号',
  passwordLabel: '密码',
  confirmPasswordLabel: '确认密码',
  confirmDeleteTitle: '请确认是否删除游戏账号及账号下所有角色',
  confirmDeleteYes: '是，我确认删除游戏账号及账号下所有角色',
  selectGame: '请选择游戏',
  confirmDeleteNo: '否，我只需要删除某个角色，游戏账号保留',
  delTermsTitle: '请您仔细阅读账号删除条件及须知',
  delCondTitle: '1. 账号删除条件',
  delCond1:
    '(1) 该游戏账号及所属游戏角色是您本人注册及使用，<span>请登录账号后再进行申请</span>，如账号无法登录，请先进行[账号找回]。',
  delCond2:
    '(2) 该游戏账号及所属游戏角色<span>无任何安全风险</span>，包括但不限于：无未处理完毕的投诉、举报、调查、仲裁、诉讼等，及未处理完毕的被投诉、被举报、被调查、被仲裁、被投诉、被诉讼等。',
  delCond3:
    '(3) 该游戏账号及所属游戏角色下<span>无任何待结清的应付未付款项</span>，包括但不限于退款未结清，订阅未取消等。',
  delNoticeTitle: '2. 账号删除须知',
  delNotice1:
    '(1) 您申请删除的是该游戏账号及所属游戏角色，一旦<span>删除完成，无法登录、无法恢复</span>。',
  delNotice2:
    '(2) 请<span>先行结清您账号及所属角色下的游戏内资产</span>，包括但不限于游戏道具，游戏代金币，游戏内订阅等，一旦删除完成，游戏内资产将会全部删除，游戏停服后，已删除账号及所属角色不安排退款。',
  delNotice3:
    '(3) 游戏账号及所属角色资料一旦删除，该账号下相关信息也会被删除或匿名化处理，但第三方社交媒体的登录信息（如Facebook关联登录等），请玩家自行解除绑定并在对应社交平台进行信息清理。',
  delNotice4:
    '(4) 为了保障您的权益，我们会为您提供14天的保留期限（部分地区基于地方法规要求除外），即冷静期，在冷静期内您可联系客服提单申请取消删除。',
  delNotice5:
    '(5) 您的账号删除一旦申请成功提交，我们会立即冻结，但删除数据需要大约一周时间才能处理完毕，因此我们会在彻底删除后第一时间对您进行邮件通知。',
  delFormConfirm1: '我已仔细阅读并知悉，删除账号的条件及后果',
  delFormConfirm2: '我申请删除的账号无相关未完结举报及诉讼',
  delForm:
    '我已阅读并同意<a class="account-delete-link" href="javascript:;">《账号注销协议》</a>',
  cannotDeleteMsgTitle: '无法进行账号删除',
  cannotDeleteMsg1: '由于您的账号未满足以下条件，因此无法进行账号删除：',
  cannotDeleteMsg2:
    '系统检查到您有客诉单未处理完成，请在客诉单完结后再次提交申请。',
  cannotDeleteMsg3:
    '系统检查到您有退款未补齐结清，请补齐退款后再提交账号删除申请。',
  cannotDeleteMsg4:
    '系统检查到您正在被其他玩家投诉或举报中，请等待客诉完结后再次提交申请。',
  formCompleted: '工单填写完毕',
  formCheckMsg1: '您的工单已填写完毕，请等待客服人工审核后回复工单。',
  formCheckMsg2:
    '您可在<span class="account-delete-link">[我的工单]</span>内查看工单处理进度。',
  delEmailMsg1: '您是否需要删除完毕后，通过邮件通知您？',
  delEmailMsg2:
    '由于账号删除需要处理数据较大，大约需要一周左右完成彻底删除，您希望我们在彻底删除完毕后，邮件通知您吗？',
  delEmailMsg3: '您填写的邮件地址仅用于通知用，不作其他用途。',
  delEmailConfirmYes: '是，请用邮件通知我',
  delEmailFill: '请填写通知邮箱',
  delEmailConfirmNo: '否，不需要邮件通知',
  delCoolMsg1: '是否选择14天冷静期？',
  delCoolMsg2:
    '在14天冷静期内，您的账号会被冻结但您可以随时提单撤销删除。14天后，如您未撤销，账号会被删除，无法恢复。',
  delCoolMsg3: '如您选择不需要冷静期，将在申请完成后执行账号删除，无法恢复。',
  delCoolConfirmYes: '是，我希望有14天冷静期',
  delCoolConfirmNo: '否，我希望现在删除',
  delSecondCheckMsg1:
    '您确定已经处理好账号全部内容，并现在执行账号冷静期？执行后您的账号无法登录',
  delSecondCheckConfirmYes: '是，马上开始',
  delResMsg1: '您的账号删除申请已经提交，以下账号已被冻结，无法登录：',
  gameName: '游戏名：',
  gameAccount: '游戏账号：',
  delResMsg2:
    '<span>请截图并复制以上账号信息，如您需要在冷静期内恢复账号，这是唯一凭证</span>',
  delResMsg3: '冷静期共14天，倒计时：',
  delResMsg4: '如您在冷静期内需要撤销删除申请，请在冷静期内点击下方[联系客服]',
  copyAccountInfo: '复制账号信息',
  delResMsg5:
    '您已完成账号删除申请，目前账号已在删除中,因此您的账号现在开始已无法登录.',
  delResMsg6:
    '由于账号删除需要处理数据较大，处理需要时间，因此账号痕迹不会马上全部抹除，我们会在大约一周内完成。',
  delResMsg7: '如您之前已经填写通知邮箱地址，我们将发送邮件至您的指定邮箱。',
  delResMsg8: '如您需要再次登录游戏，可重新注册新账号登录。',
  appleOption: 'App Store',
  googleOption: 'Google Play',
  otherOption: '其他渠道',
  itemWrong: '该项填写有误，请重新输入',
  delRegisterTime: '注册时间',
  delDevice: '常用机型',
  delIp: '常用IP',
  delHistoryPayChannel: '历史充值渠道',
  delHistoryPayOrder: '历史充值订单号',
  delDeleteReason: '删号原因',
  delPrevStep: '上一步',
  delNextStep: '下一步',
  delSecondCheckMsg2:
    '您确定已经处理好账号全部内容，并现在执行账号删除？执行后您的账号无法登录',
  pleaseFillIn: '请填写以下信息',
  switchNewVersion: '切换至新版本',
  switchNewVersionPlatform: '支付平台',
  updateVersionPopupContent: '为确保流畅的游戏性能及后续新功能的支持，我们推荐您将设备系统升级，以便享受更稳定的运行体验与兼容性优化。',
  selectTopupTips: "90%的用户选择官方充值中心",
  chuzhi: "储值",
  selectMethods: "支付方式",
  landscapeTip2: "请将手机竖屏使用以获得更好的体验",
  v3LaunchFromDesktopAndRewardToMailbox: '请从桌面启动\n选择角色后奖励将发至邮箱',
  ckoNotAvailable: '支付服务异常，请稍后重试。',
  ckoSubmitFail: '支付失败，请核对信息或换卡支付。如已扣款，将原路退回。',
  gotoFinish: '去完成',
  inAppPurchase: '应用内购买'
};
